import store from '../../../store'
import * as apiActions from 'actions/apiActions'

// 2020-03-09
// Andrew requests that we poll the server occasionally to pull from the
// server any timers we aren't currently tracking in this client
// (any timers that were created in another browser window).
// Otherwise, his preference is to not READ_ALL after every CREATE/DELETE.
const SERVER_REFRESH_INTERVAL_SECONDS = 60

const selectMovement = state => state.timer.movement

class TimerMovement {
  __construct() {
    this.timeout = null
    this.unsubscribe = null
    this.currentState = {}
  }

  start = () => {
    this.stop()
    if (!this.unsubscribe) {
      this.unsubscribe = store.subscribe(this.handleStoreUpdate)
      this.handleStoreUpdate()
      const tick = this.handleTick()
      console.debug('[TimerMovement] started at ' + tick)
      // initial load of timers from server handled by globalAppConfigAuth
    }
  }

  stop = () => {
    if (this.timeout) {
      clearTimeout(this.timeout)
      this.timeout = null
    }
    if (this.unsubscribe) {
      this.unsubscribe()
      this.unsubscribe = null
      console.debug('[TimerMovement] stopped')
    }
  }

  handleTick = () => {
    const time = Date.now()
    const mod = time % 1000
    const clientTick = time - mod
    const epochTime = Math.floor(time / 1000) - this.currentState.clientDelta

    store.dispatch({
      type: 'TIMER_MOVEMENT_TICK',
      clientTick,
      mod,
      epochTime
    })

    this.timeout = setTimeout(this.handleTick, 1000 - mod + 1)
    return clientTick
  }

  handleStoreUpdate = () => {
    const nextState = selectMovement(store.getState())
    if (nextState === this.currentState) {
      // nothing to do
      return
    }

    const prevState = this.currentState
    this.currentState = nextState
    // console.debug('[TimerMovement] state update', nextState)

    if (
      nextState.refreshStartTick &&
      nextState.refreshStartTick !== nextState.clientTick &&
      (nextState.epochTime % SERVER_REFRESH_INTERVAL_SECONDS) -
        nextState.refreshOffset ==
        0
    ) {
      console.debug(
        '[TimerMovement] update timer from server',
        new Date().toUTCString(),
        nextState
      )
      store.dispatch(apiActions.xtractAPI('timer', 'READ_ALL', undefined, undefined, { downlink: true }))
    }
  }
}

const movement = new TimerMovement()
export default movement
